var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstaGreyIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_161037",
    "data-name": "Group 161037",
    transform: "translate(-218 -356)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_161033",
    "data-name": "Group 161033",
    transform: "translate(0 -5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_287",
    "data-name": "Ellipse 287",
    cx: 11,
    cy: 11,
    r: 11,
    transform: "translate(218 361)",
    fill: "#a6a8bb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Instagram_2",
    "data-name": "Instagram 2",
    transform: "translate(218.285 361.024)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1661",
    "data-name": "Path 1661",
    d: "M104.173,110.777c-.838-.006-1.5-.006-2.164-.017-.368,0-.729-.025-1.094-.049a4.362,4.362,0,0,1-1.452-.34,3.394,3.394,0,0,1-1.87-1.948,4.419,4.419,0,0,1-.259-1.065c-.031-.254-.047-.508-.054-.763-.012-.491-.027-.982-.031-1.48v-2.176c0-.315,0-.632.011-.946s.02-.614.038-.913a4.627,4.627,0,0,1,.358-1.6,3.385,3.385,0,0,1,1.853-1.818,4.333,4.333,0,0,1,1.31-.311c.592-.053,1.187-.065,1.781-.065h3.2c.422,0,.846.023,1.267.052a4.329,4.329,0,0,1,1.459.339,3.389,3.389,0,0,1,1.877,1.964,4.482,4.482,0,0,1,.264,1.13c.032.285.041.569.053.859.025.567.023,1.133.023,1.7v2.3c0,.422-.021.844-.041,1.267a5.02,5.02,0,0,1-.218,1.273,3.5,3.5,0,0,1-.614,1.173,3.447,3.447,0,0,1-1.554,1.1,4.438,4.438,0,0,1-1.141.245c-.324.026-.651.045-.976.052C105.467,110.766,104.733,110.771,104.173,110.777Zm-5.706-6.75v.631c0,.614,0,1.219.026,1.829.011.253.02.506.053.756a3.176,3.176,0,0,0,.233.868,2.177,2.177,0,0,0,1.032,1.087,2.968,2.968,0,0,0,1.1.3c.286.025.573.039.859.048.387.012.773.017,1.159.017q1.452,0,2.9-.009c.411,0,.824-.016,1.227-.055a3.334,3.334,0,0,0,.907-.206,2.192,2.192,0,0,0,1.2-1.095,3,3,0,0,0,.288-1.114c.025-.3.039-.608.048-.912.011-.388.015-.777.016-1.165v-2.156c0-.356-.009-.713-.018-1.069-.007-.3-.017-.6-.052-.9a3.229,3.229,0,0,0-.218-.878,2.179,2.179,0,0,0-1.078-1.152,2.935,2.935,0,0,0-1.076-.284c-.317-.027-.633-.043-.951-.052-.41-.012-.82-.016-1.227-.015-1.206,0-2.413-.021-3.618.037a4.823,4.823,0,0,0-.848.1,2.524,2.524,0,0,0-.8.318,2.231,2.231,0,0,0-.935,1.19,3.819,3.819,0,0,0-.188,1.028c-.02.368-.034.736-.038,1.112,0,.574,0,1.733,0,1.733Z",
    transform: "translate(-93.281 -93.314)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1662",
    "data-name": "Path 1662",
    d: "M127.677,131.342a3.71,3.71,0,1,1,2.627-1.085A3.711,3.711,0,0,1,127.677,131.342Zm-2.4-3.719a2.409,2.409,0,1,0,.713-1.7A2.409,2.409,0,0,0,125.275,127.623Z",
    transform: "translate(-116.967 -116.921)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1663",
    "data-name": "Path 1663",
    d: "M175.843,116.21a.867.867,0,1,1-.874.854A.867.867,0,0,1,175.843,116.21Z",
    transform: "translate(-161.443 -110.046)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaGreyIcon);
export default __webpack_public_path__ + "static/media/insta-grey-icon.a043a9b98bd6b0f18e312a6085e87380.svg";
export { ForwardRef as ReactComponent };